const API_URL = process.env.REACT_APP_LOCAL_API;
const API_TOKEN = process.env.REACT_APP_LOCAL_API_TOKEN;

const fetchCategoryTemplates = async () => {
  const response = await fetch(`${API_URL}?is_video=false`, {
    method: "GET",
    headers: {
      Authorization: `token ${API_TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Error: ${response.status}`);
  }

  const data = await response.json();

  return data;
};

const getSpecificCategoryTemplate = async (
  category,
  page,
  pagination,
  is_video,
) => {
  const params = category;

  if (!pagination) {
    return;
  }

  try {
    const response = await fetch(
      `${API_URL}/api/specific_category_templates/v3?category_id=${params}&page=${page}&pagination=${pagination}&is_video=${is_video || false}&face_type=both&only_videos=${is_video || false}&origin=web`,

      {
        method: "GET",
        headers: {
          Authorization: `token ${API_TOKEN}`,
        },
        // redirect: "follow",
      },
    );

    if (!response.ok) {
      console.error(`Fetch error: ${response.status} - ${response.statusText}`);
      throw new Error(`Error: ${response.status} - ${response.statusText}`);
    }

    const data = await response.json();
    console.log({ data });
    return data;
  } catch (error) {
    console.error("Error fetching specificCategoryTemplate:", error);
    throw error;
  }
};

const updateMultipleTemplates = async (templates) => {
  console.log(templates);
  const url = `${API_URL}/api/update_multiple_templates/v2/?face_type=both`;

  const headers = new Headers({
    Authorization: `token ${API_TOKEN}`,
    "Content-Type": "application/json",
    Token: process.env.REACT_APP_LOCAL_API_TOKEN,
  });

  const requestOptions = {
    method: "PUT",
    headers,
    body: JSON.stringify(templates),
    redirect: "follow",
  };
  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      const errorText = `Request failed with status ${response.status} - ${response.statusText}`;
      console.error(errorText);
      throw new Error(errorText);
    }

    const result = await response.json();
    console.log({ result });
    return result;
  } catch (error) {
    console.error("Error updating templates:", error.message);
    throw error;
  }
};

const updatePremiumTemplates = async (templates) => {
  console.log(templates);
  const url = `${API_URL}/api/update_premium_for/`;

  const headers = new Headers({
    Authorization: `token ${API_TOKEN}`,
    "Content-Type": "application/json",
    Token: process.env.REACT_APP_LOCAL_API_TOKEN,
  });

  const requestOptions = {
    method: "PUT",
    headers,
    body: JSON.stringify(templates),
    redirect: "follow",
  };
  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      const errorText = `Request failed with status ${response.status} - ${response.statusText}`;
      console.error(errorText);
      throw new Error(errorText);
    }

    const result = await response.text();
    return result;
  } catch (error) {
    console.error("Error updating templates:", error.message);
    throw error;
  }
};

const updateTemplateAnimation = async (templateID, animationFile) => {
  const url = `${API_URL}/api/update/template/animation/`;

  // Create headers
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `token ${API_TOKEN}`);

  // Prepare form data
  const formdata = new FormData();
  formdata.append("templateID", templateID);
  formdata.append("animationfile", animationFile);

  // Request options
  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  try {
    // Make the API call
    const response = await fetch(url, requestOptions);

    // Handle non-successful responses
    if (!response.ok) {
      const errorText = `Request failed with status ${response.status} - ${response.statusText}`;
      console.error(errorText);
      throw new Error(errorText);
    }

    // Parse and return the response text
    const result = await response.text();
    return result;
  } catch (error) {
    console.error("Error updating template animation:", error.message);
    throw error;
  }
};

export {
  fetchCategoryTemplates,
  getSpecificCategoryTemplate,
  updatePremiumTemplates,
  updateMultipleTemplates,
  updateTemplateAnimation,
};
